import { EComponent, IModelRaw } from './base';
import { ICategory } from './category.model';
import { IPhase } from './phase.model';
import { IRegion } from './region.model';
import { ITag } from './tag.model';

export enum EPostType {
  Blog = 'blog',
  Link = 'link',
  Table = 'table',
}

export enum EScope {
  News = 'news',
  GreenHub = 'greenhub',
}

export interface IPostModel extends IModelRaw {
  slug_vi: string;

  title_en: string;

  title_vi: string;

  content_en: string | IListContentItem[];

  short_content_en: string;

  content_vi: string | IListContentItem[];

  short_content_vi: string;

  picture?: string | null;
  background_image?: string | null;

  link?: string;
  link_en?: string;
  link_vi?: string;

  visible: boolean;
  scope?: EScope;

  reading_min: number;

  type: EPostType;

  component: EComponent;

  published_at?: string;

  category?: ICategory | null;
  category_id?: string | null;

  tags?: ITag[];
  tag_ids?: string[];

  region?: IRegion | null;

  region_id?: string | null;
  phase?: IPhase | null;
  phase_id?: string | null;

  order?: number;
}

export interface IListContentItem {
  id: string;
  name: string;
  location: string;
  order: number;
  header?: boolean;
}
